// Import the functions you need from the SDKs you need
// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyClwIIlIRoEelWeON5WPGryHi4N4ZxOlho",
    authDomain: "onefurever-user.firebaseapp.com",
    projectId: "onefurever-user",
    storageBucket: "onefurever-user.firebasestorage.app",
    messagingSenderId: "662604293998",
    appId: "1:662604293998:web:b57db0fd3251757cd1437f"
  };

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider};